import React from "react";
import styled from "styled-components";
import {Button} from "@material-ui/core";
import i18n from "i18next";
import {inject, observer} from "mobx-react";

const LogoEditorStyled = styled.div`
    display: flex;
    flex: 1;
    div{
      flex:1
    }
`;

declare global {
    interface Window {
        wp: any;
    }
}

@inject("uiStore")
@observer
class LogoEditor extends React.Component<any, any> {


    frame: any;

    onSelect = () => {
        const attachment = this.frame.state().get('selection').first().toJSON();
        this.props.onUpdateData('src', attachment.url);
    };

    openMedia = () => {
        this.frame.open();
    }

    componentWillMount(): void {
        const wp = window.wp;
        this.frame = wp.media.frames.file_frame = wp.media({
            multiple: false
        });
        this.frame.on('select', this.onSelect);
    }

    componentWillUnmount(): void {
        try {
            this.frame.off(this.onSelect);
        } catch (e) {
        }
    }

    render(): React.ReactElement<any, string | React.JSXElementConstructor<any>> | string | number | {} | React.ReactNodeArray | React.ReactPortal | boolean | null | undefined {

        return (
            <LogoEditorStyled dir={this.props.uiStore.dir}>
                <Button variant="contained" color="primary" onClick={this.openMedia}>
                    {i18n.t("Open wordpress gallery")}
                </Button>
                {/*<TextField*/}
                {/*    variant="outlined"*/}
                {/*    id="standard-name"*/}
                {/*    label={i18n.t("Logo src label")}*/}
                {/*    value={this.props.widget.data.src}*/}
                {/*    onChange={(event) => this.props.onUpdateData('src', event.target.value)}*/}
                {/*    margin="normal"*/}
                {/*/>*/}
            </LogoEditorStyled>
        );
    }
}

export default LogoEditor;

